import DriversManagerDashboard from './DriversManagerDashboard';
export default  DriversManagerDashboard;



// WEBPACK FOOTER //
// ./src/components/App/DriversManagerDashboard/index.js